import { Component } from '@angular/core';

@Component({
  selector: 'lp-authentication',
  imports: [],
  templateUrl: './lexplus-authentication.html',
  styleUrl: './lexplus-authentication.css',
})
export class LexplusAuthentication {}
